import axios from 'axios';

export class BetaFlagService {
  static async fetchBetaFlag(flag: string) {
    const body: FormData = new FormData();
    body.append('flag', flag);

    const {
      data: { value },
    } = await axios.post('/get/beta/flag', body);

    return value;
  }

  static async setBetaFlag(flag: string, value: string) {
    const body: FormData = new FormData();
    body.append('action', 'flag');
    body.append('flag', flag);
    body.append('value', value);

    const { data } = await axios.post('/save/beta', body);

    return data && data.value;
  }
}
